import React from 'react';
import Layout from '../Layout/Layout';
import Transactions from "../components/Transactions/Transactions";
import { useAuth } from '../hooks/AuthContext';
import { useTransactions } from '../hooks/TransactionsContext';
import { useNavigation } from '../hooks/useNavigation';

const TransactionsContainer = () => {
    const { logout } = useAuth();
    const { transactions } = useTransactions();
    const navigation = useNavigation();

    const columns = [
        { header: 'Status', accessor: 'isValid' },
        { header: 'Data', accessor: 'date' },
        { header: 'Valor', accessor: 'value' },
        { header: 'Origem', accessor: 'origin' },
        { header: 'Banco', accessor: 'bank' },
    ];

    return (
        <Layout
            logout={logout}
            {...navigation}
        >
            <Transactions
                columns={columns}
                data={transactions}
            />
        </Layout>
    );
};

export default TransactionsContainer;
